import SystemAnalyticsComponent from '../Components/SystemAnalyticsComponent';

function SystemAnalyticsPage() {
  return <SystemAnalyticsComponent />;
}

export default SystemAnalyticsPage;